export const excelExportResourcesFields = {
  news: {
    id: {
      title: 'id',
      selected: false,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    copy_count: {
      title: 'copy_count',
      selected: true,
    },
    post_count: {
      title: 'post_count',
      selected: true,
    },
    original_count: {
      title: 'original_count',
      selected: true,
    },
    media_type: {
      title: 'media_type',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  instagram: {
    id: {
      title: 'id',
      selected: false,
    },
    ages: {
      title: 'ages',
      selected: true,
    },
    url: {
      title: 'url',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    image: {
      title: 'image',
      selected: false,
    },
    title: {
      title: 'title',
      selected: true,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    gender: {
      title: 'gender',
      selected: true,
    },
    post_count: {
      title: 'post_count',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    influence_category: {
      title: 'influence_category',
      selected: true,
    },
    description: {
      title: 'description',
      selected: false,
    },
    follower_count: {
      title: 'follower_count',
      selected: true,
    },
    following_count: {
      title: 'following_count',
      selected: true,
    },
    political_direction_total: {
      title: 'political_direction_total',
      selected: false,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  instagramCommentByPost: {},
  instagramComment: {},
  twitter: {
    id: {
      title: 'id',
      selected: false,
    },
    ages: {
      title: 'ages',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    title: {
      title: 'title',
      selected: true,
    },
    image: {
      title: 'image',
      selected: false,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    username: {
      title: 'username',
      selected: true,
    },
    influence_category: {
      title: 'influence_category',
      selected: true,
    },
    gender: {
      title: 'gender',
      selected: true,
    },
    post_count: {
      title: 'post_count',
      selected: true,
    },
    description: {
      title: 'description',
      selected: true,
    },
    like_count: {
      title: 'like_count',
      selected: true,
    },
    follower_count: {
      title: 'follower_count',
      selected: true,
    },
    following_count: {
      title: 'following_count',
      selected: true,
    },
    time: {
      title: 'time',
      selected: false,
    },
    copy_count: {
      title: 'copy_count',
      selected: true,
    },
    total_post_count: {
      title: 'total_post_count',
      selected: true,
    },
    mentions_count: {
      title: 'mentions_count',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: true,
    },
    political_direction_total: {
      title: 'political_direction_total',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  telegram: {
    id: {
      title: 'id',
      selected: false,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    description: {
      title: 'description',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    influence_category: {
      title: 'influence_category',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    member_count: {
      title: 'member_count',
      selected: false,
    },
    post_count: {
      title: 'post_count',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    weekly_publish_rate: {
      title: 'weekly_publish_rate',
      selected: false,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  newspaper: {
    id: {
      title: 'id',
      selected: false,
    },
    url: {
      title: 'url',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
  nativePlatforms: {
    id: {
      title: 'id',
      selected: false,
    },
    avatar: {
      title: 'avatar',
      selected: false,
    },
    description: {
      title: 'description',
      selected: true,
    },
    extracted_hashtag: {
      title: 'extracted_hashtag',
      selected: true,
    },
    extracted_mention: {
      title: 'extracted_mention',
      selected: true,
    },
    extracted_url: {
      title: 'extracted_url',
      selected: true,
    },
    influence_category: {
      title: 'influence_category',
      selected: true,
    },
    lang: {
      title: 'lang',
      selected: false,
    },
    member_count: {
      title: 'member_count',
      selected: false,
    },
    platform: {
      title: 'platform',
      selected: true,
    },
    political_direction_total: {
      title: 'political_direction_total',
      selected: true,
    },
    title: {
      title: 'title',
      selected: true,
    },
    username: {
      title: 'username',
      selected: true,
    },
    pid: {
      title: 'pid',
      selected: false,
    },
  },
};
